<template>
    <div class="mt-2">
        <div v-if="loading">
            <content-placeholders>
                <content-placeholders-text :lines="3"/>
            </content-placeholders>
        </div>
        <div v-else>
            <div class="d-flex align-items-center justify-content-between pt-2 pb-2">
                <div class="col-8 radio-group">
                    <div class="radio-item">
                        <b-form-radio switch v-model="type" value="Parent Article">
                            Parent Articles
                        </b-form-radio>
                    </div>
                    <div class="radio-item">
                        <b-form-radio switch v-model="type" value="Child Article">
                            Child Articles
                        </b-form-radio>
                    </div>
                    <div class="radio-item">
                        <b-form-radio switch v-model="type" value="Linked Article">Linked Articles</b-form-radio>
                    </div>
                    <div class="radio-item">
                        <b-form-radio switch v-model="type" value="all">All</b-form-radio>
                    </div>
                </div>
                <CopyToClipboardButton
                    size="sm"
                    :value="copyablePedigreeChartHtml"
                    :as-html="true"
                />
            </div>
            <b-list-group>
                <b-list-group-item
                    v-for="(item, index) in visiblePedigreeChart"
                    :key="index"
                >
                    <div class="d-flex align-items-center row">
                        <div class="col">
                            <div class="text-muted">
                                <small>Publication</small>
                            </div>
                            <div>
                                <router-link :to="{path: '/publications/' + item.publication_id}" target="_blank">
                                    {{ item.sku }}
                                </router-link>
                                <div
                                    v-if="item.publication_category === 'retired'"
                                    class="text-danger font-italic small"
                                >
                                    Retired
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="text-muted">
                                <small>Week</small>
                            </div>
                            <div class="d-flex align-items-center">
                                <div class="mr-1">
                                    <span>{{ item.week_number }}.</span>
                                </div>
                                <div v-if="item.publication_id == publication.id">
                                    <a
                                        href="#"
                                        v-scroll-to="{
                                            el: '#unit' + item.unit_id,
                                            offset: -144
                                        }"
                                    >
                                        <span v-if="item.title">{{ item.week_title }}</span>
                                        <span v-else class="text-muted">no title</span>
                                    </a>
                                </div>
                                <div v-else>
                                    <router-link
                                        :to="{
                                            path: '/publications/' + item.publication_id,
                                            query: { unit_id: item.unit_id }
                                        }"
                                        target="_blank"
                                    >
                                        <span v-if="item.title">{{ item.title }}</span><span v-else class="text-muted">no title</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.publication_id !== publication.id" class="col">
                            <div class="text-muted">
                                <small>Article</small>
                            </div>
                            <router-link
                                :to="{
                                    path: '/publications/' + item.publication_id,
                                    query: { unit_id: item.unit_id, article_id: item.id }
                                }"
                                target="_blank">
                                <span v-if="article.title">{{ article.title }}</span>
                                <span v-else class="text-muted">no title</span>
                            </router-link>
                        </div>
                        <div v-else class="col">
                            <div v-if="unit.articles_visible">
                                <div class="text-muted">
                                    <small>Article</small>
                                </div>
                                <a
                                    href="#"
                                    v-scroll-to="{
                                        el: '#unit' + item.unit_id + 'article' + article.article_id,
                                        offset: -144
                                    }"
                                >
                                    <span v-if="article.title">{{ article.title }}</span>
                                    <span v-else class="text-muted">no title</span>
                                </a>
                            </div>
                            <div v-else>
                                <div class="text-muted">
                                    <small>Article</small>
                                </div>
                                <a
                                    href="#"
                                    v-scroll-to="{el: '#unit' + item.unit_id, offset: -144}"
                                >
                                    <span v-if="article.title">{{ article.title }}</span>
                                    <span v-else class="text-muted">no title</span>
                                </a>
                            </div>
                        </div>
                        <div class="col">
                            <div class="text-muted">
                                <small>Article ID</small>
                            </div>
                            <div>
                                {{ item.id }}
                            </div>
                        </div>
                        <div class="pt-3 col">
                            <div>
                                <span v-if="unit.id === item.unit_id" class="badge badge-primary ml-3">Self</span>
                                <span v-else class="badge badge-primary ml-3">{{ item.relationship_type }}</span>
                            </div>
                            <div v-if="item.is_trunk === 1" class="mt-2">
                                <span class="badge badge-success ml-3">Trunk</span>
                            </div>
                        </div>
                    </div>
                </b-list-group-item>
                <b-list-group-item variant="success">
                    End of list
                </b-list-group-item>

            </b-list-group>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.radio-group {
    display: flex;
    justify-content: space-between;
}

.radio-item {
    flex: 1;
    margin-right: 10px;
}
</style>

<script>
import CopyToClipboardButton from '@/components/CopyToClipboardButton'

export default {
    components: {
        CopyToClipboardButton,
    },
    props: [
        'article',
        'unit',
        'publication',
    ],
    data: () => ({
        loading: false,
        pedigreeChart: [],
        type: 'all',
    }),
    computed: {
        visiblePedigreeChart() {
            return this.pedigreeChart.filter((item) => {
                return this.type === 'all' || this.type === item.relationship_type
            })
        },
        copyablePedigreeChartRows() {
            return [
                ['Publication', 'Week', 'Article', 'Article ID', 'Relationship'],
                ...this.visiblePedigreeChart.map((item) => {
                    return [
                        item.publication_category === 'retired' ? `${item.sku} (Retired)` : item.sku,
                        `${item.week_number}. ${item.title || 'no title'}`,
                        this.article.title || 'no title',
                        item.id,
                        this.unit.id === item.unit_id ? 'Self' : item.relationship_type,
                    ]
                }),
            ]
        },
        copyablePedigreeChartHtml() {
            return this.rowsToHtml(this.copyablePedigreeChartRows)
        },
    },
    methods: {
        formatClipboardCell(value) {
            return String(value || '').replace(/\s+/g, ' ').trim()
        },
        rowsToHtml(rows) {
            const tableRows = rows.map((row, rowIndex) => {
                const cellTag = rowIndex === 0 ? 'th' : 'td'
                const cells = row.map((cell) => {
                    return `<${cellTag}>${this.formatClipboardCell(cell)}</${cellTag}>`
                }).join('')

                return `<tr>${cells}</tr>`
            }).join('')

            return `<table>${tableRows}</table>`
        },
        async getPedigreeChart() {
            this.loading = true;

            try {
                const response = await this.axios.get(`/api/articles/article_pedigree/${this.article.id}`)
                this.pedigreeChart = response.data
            } catch (e) {

            } finally {
                this.loading = false
            }
        },
    },
    watch: {
        'article.predigree_chart_visible': {
            handler (visible) {
                if (visible) {
                    this.getPedigreeChart()
                }
            },
            deep: true
        }
    },
}
</script>
